import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: { textAlign: 'left' } }
const _hoisted_2 = { style: {
              marginRight: '100px',
              width: '300px',
              display: 'inline-block'
            } }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 取消 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 确定 ")

import { computed, ref, onMounted, onBeforeMount } from 'vue'
import SelectBookModal from '@/views/songs/components/SelectBookModal.vue'
import {
  getOfficialTags,
  shareCourseware,
  getTeacherAreaInfo
} from '@/views/mine-coursewares/service'
import { debounce } from 'lodash'
import { message } from 'ant-design-vue'
import { useStore } from 'vuex'
import { list2tree } from '@/utils/common'
import { SearchOutlined } from '@ant-design/icons-vue'
import { moduleCodeEnum } from '@/utils/dataMap/teachingMaterial'
import ProtocolsModal from './protocolsModal.vue'
import { Protocols } from '@/utils/dataMap/userProtocols'


export default /*#__PURE__*/_defineComponent({
  props: {
  courseware: {
    type: Object
  },
  visible: {
    type: Boolean,
    default: false
  }
},
  emits: ['onCancel', 'onOk'],
  setup(__props, { emit }) {

const props = __props




const store = useStore()

// 是否课件
const visibleCompu = computed(() => props.visible)

// 课件节点信息，课件真实信息在他的courseware中
const courInfo = ref<any>(props.courseware)

// 教材名
const title = ref<string>(courInfo.value?.name || '')

// 教材类型
const bookTypeMap = {
  OFFICIAL: 1 // 官方的
}

// 显示选择教材弹窗
const selectBookModalVisible = ref<boolean>(false)
// 选择的教材显示名称
const bookShowName = ref<string>()

// 区域信息
const areaOpts = ref<any[]>([])

// 选择分享范围
const selectShareType = [
  { label: '平台公开', value: 0 },
  { label: '学校公开', value: 1 },
  { label: '区域公开', value: 2 }
]

const CoursewareType = {
  plan: '教案',
  speak: '说课'
}
const courInfoType = courInfo?.value?.courseware?.type
const coursewareInfoType = CoursewareType[courInfoType]
  ? CoursewareType[courInfoType]
  : '课件'

// 分享类型
const shareTypeMap = {
  PLATFROM: 0,
  SCHOOL: 1,
  AREA: 2
}

// tag数据
const tagsList = ref<any[]>()

const formRef = ref<any>()

const formData = ref<any>({
  name: courInfo.value.name,
  official_book_id: undefined,
  official_book_section_id: undefined,
  publish_type: undefined,
  publish_ins_id: undefined,
  tags: undefined
})

// 提交等待
const submitLoading = ref<boolean>(false)

// 显示协议
const protocolsVisible = ref<boolean>(false)

const hasAccessProtocols = ref<boolean>(false)
const hasAccessProtocolsUpdateTime = ref<string>()

const cascaderInfo = ref<number[]>([])

const bookSectionRef = ref<any>()

// 取消
const handleCancel = () => {
  emit('onCancel')
}

// 整个表单选择完毕
const handleOkClick = () => {
  if (hasAccessProtocols.value === false) {
    message.error('请阅读并同意《内容上传服务协议》')
    return
  }
  formRef.value.validate().then(async () => {
    submitLoading.value = true
    // 发送分享课件请求
    const params = formData.value
    const cid = courInfo.value.courseware.id
    try {
      await shareCourseware(cid, params)
      message.success('提交分享成功，请耐心等待审核')
      submitLoading.value = false
      emit('onOk')
    } catch (err) {
      console.error(err)
      message.error('提交分享失败， 请重试')
      submitLoading.value = false
    }
  })
}

// 选择教材章节展示
const handleShowSelectBookModal = () => {
  selectBookModalVisible.value = true
}

// 选择教材章节结束
const handleSelectBookOk = (value: any) => {
  console.log(value)
  const ids = value.values
  const labels = value.labels
  if (labels && labels.length > 0) {
    bookShowName.value = labels.join('/')
  } else {
    bookShowName.value = ''
  }
  if (ids[0]) {
    formData.value.official_book_id = ids[0]
  } else {
    formData.value.official_book_id = undefined
  }
  if (ids[1]) {
    formData.value.official_book_section_id = ids[1]
  } else {
    formData.value.official_book_section_id = undefined
  }
  selectBookModalVisible.value = false
  if (bookSectionRef.value?.focus) {
    bookSectionRef.value.focus()
  }
}

// 搜索tag
const handleTagsSearch = debounce(async value => {
  const tagsInfos = await getOfficialTags({
    keyword: value,
    current: 1,
    per_page: 20
  })
  if (tagsInfos.items.length > 0) {
    tagsList.value = tagsInfos.items.map((item: { tag: any }) => {
      return { label: item.tag, value: item.tag }
    })
  } else {
    tagsList.value = [{ label: value, value: value }]
  }
})

const handleUploadProtocolChange = (protocol) => {
  const currentUser = store.state.currentUser
  const teacherId = currentUser.id
  localStorage.setItem(`uploadProtocol_${teacherId}`, JSON.stringify(protocol))
}
const initUploadProtocol = () => {
  const currentUser = store.state.currentUser
  const teacherId = currentUser.id
  const localProtocol = JSON.parse(localStorage.getItem(`uploadProtocol_${teacherId}`) || '{ "checked": false }')
  hasAccessProtocols.value = localProtocol.checked
  hasAccessProtocolsUpdateTime.value = localProtocol.update_time
}

// 关闭协议展示
const handleProtocolsCancel = () => {
  protocolsVisible.value = false
}

const handleInitArea = async () => {
  console.log('初始化区域信息')
  const currentUser = store.state.currentUser
  const schoolId = currentUser?.school_id
  console.log(currentUser)
  if (schoolId) {
    let info: { uplevel_ins_data: any[] } = { uplevel_ins_data: [] }
    info = await getTeacherAreaInfo({ school_id: schoolId })
    const list = info.uplevel_ins_data.map(item => ({
      id: item.id,
      value: item.id,
      parent_id: item.parent_id,
      label: item.name
    }))
    if (list && list?.length > 0) {
      areaOpts.value = list2tree(list, { rootId: 0 })
    }
  }
}

const handleCascaderChange = () => {
  formData.value.publish_ins_id =
    cascaderInfo.value[cascaderInfo.value?.length - 1] || undefined
}

const handleValidatorBook = async () => {
  return new Promise((resolve: any, reject: (arg0: any) => void) => {
    if (
      !formData.value.official_book_section_id ||
      !formData.value.official_book_id
    ) {
      reject(new Error('请选择教材及章节'))
    } else {
      resolve()
    }
  })
}

onBeforeMount(() => {
  initUploadProtocol()
})
onMounted(() => {
  // 初始化组件的时候先检索加载一次tag信息
  handleTagsSearch(undefined)
  // 初始化地址信息
  handleInitArea()
})

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_show_protocols_modal = _resolveComponent("show-protocols-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      title: `分享${_unref(coursewareInfoType)}：${title.value}`,
      visible: _unref(visibleCompu),
      width: 600,
      onCancel: handleCancel,
      maskClosable: false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, [
            _createVNode(ProtocolsModal, {
              checked: hasAccessProtocols.value,
              "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => (hasAccessProtocols.value = $event)),
              update_time: hasAccessProtocolsUpdateTime.value,
              protocol: _unref(Protocols).UploadServiceAgreement,
              onChange: handleUploadProtocolChange
            }, null, 8, ["checked", "update_time", "protocol"])
          ]),
          _createVNode(_component_a_button, {
            onClick: handleCancel,
            disabled: submitLoading.value
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_a_button, {
            onClick: handleOkClick,
            type: "primary",
            loading: submitLoading.value
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: (_value, _refs) => {
            _refs['formRef'] = _value
            formRef.value = _value
          },
          model: formData.value,
          labelCol: { span: 5 },
          wrapperCol: { span: 16 }
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_a_form_item, {
              label: "课件名",
              name: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: formData.value.name,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (formData.value.name = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512), [
              [_vShow, false]
            ]),
            _createVNode(_component_a_form_item, {
              label: "所属教材章节",
              name: "official_book_id",
              rules: [
            {
              required: true,
              validator: handleValidatorBook,
              trigger: ['change', 'blur']
            }
          ]
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  href: "#",
                  onClick: handleShowSelectBookModal
                }, _toDisplayString(bookShowName.value || "请选择教材章节"), 1)
              ]),
              _: 1
            }, 8, ["rules"]),
            _withDirectives(_createVNode(_component_a_form_item, {
              label: "所属教材章节",
              name: "official_book_section_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  ref: (_value, _refs) => {
                    _refs['bookSectionRef'] = _value
                    bookSectionRef.value = _value
                  }
                }, null, 512)
              ]),
              _: 1
            }, 512), [
              [_vShow, false]
            ]),
            _createVNode(_component_a_form_item, {
              label: "分享范围",
              name: "publish_type",
              rules: { required: true, message: '请选择分享范围' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: formData.value.publish_type,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (formData.value.publish_type = $event)),
                  placeholder: "选择分享范围",
                  style: {"width":"100%"},
                  options: selectShareType
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            (formData.value.publish_type === shareTypeMap.AREA)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "分享区域",
                  name: "publish_ins_id",
                  rules: { required: true, message: '请选择分享的区域' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_cascader, {
                      onChange: handleCascaderChange,
                      "change-on-select": "",
                      placeholder: "请选择分享区域",
                      value: cascaderInfo.value,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (cascaderInfo.value = $event)),
                      options: areaOpts.value
                    }, null, 8, ["value", "options"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form_item, {
              label: "标签",
              name: "tags"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: formData.value.tags,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (formData.value.tags = $event)),
                  mode: "multiple",
                  placeholder: "可检索标签",
                  style: {"width":"100%"},
                  options: tagsList.value,
                  onSearch: _unref(handleTagsSearch)
                }, {
                  suffixIcon: _withCtx(() => [
                    _createVNode(_unref(SearchOutlined))
                  ]),
                  _: 1
                }, 8, ["value", "options", "onSearch"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["title", "visible"]),
    _createVNode(SelectBookModal, {
      ref: (_value, _refs) => {
        _refs['modalRef'] = _value
      },
      type: bookTypeMap.OFFICIAL,
      visible: selectBookModalVisible.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => (selectBookModalVisible.value = $event)),
      onOk: handleSelectBookOk,
      queryParams: { show_modules: _unref(moduleCodeEnum).standardCourse }
    }, null, 8, ["type", "visible", "queryParams"]),
    (protocolsVisible.value)
      ? (_openBlock(), _createBlock(_component_show_protocols_modal, {
          key: 0,
          visible: protocolsVisible.value,
          onOnCancel: handleProtocolsCancel
        }, null, 8, ["visible"]))
      : _createCommentVNode("", true)
  ]))
}
}

})